//Custom components

import { DocumentIcon } from '@heroicons/react/24/outline';
import { PatternFormat as NumberFormat } from 'react-number-format';
//Services
import { useApplicationFormContext } from '@/features/ApplicationForm/ApplicationFormProvider';
import { accountingFormatNumber, formatDate3 } from '@/utils';
import ReviewCard from './ReviewCard';

export default function Review() {
  const { setCurrentStep, data } = useApplicationFormContext();

  const { application, householdIncome, propertyInformation, attachments } = data;
  console.log(attachments);
  return (
    <div className={'space-y-5 px-6 py-4 lg:col-span-9'}>
      <ReviewCard title='Application Information' handleEdit={() => setCurrentStep(0)}>
        <dl>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Name</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>{application?.name}</dd>
          </div>

          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Street Address</dt>
            <dd className='mt-1 text-sm text-gray-900 normal-case sm:mt-0 sm:col-span-2'>{application?.streetAddress}</dd>
          </div>

          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>City</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>{application?.city}</dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>State / Province</dt>
            <dd className='mt-1 text-sm text-gray-900 normal-case sm:mt-0 sm:col-span-2'>{application?.state}</dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Zip / Postal Code</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{application?.zipCode}</dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Home Phone</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>
              <NumberFormat value={application?.homePhone} format='+1 (###) ###-####' displayType={'text'} />
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Work Phone</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>
              <NumberFormat value={application?.workPhone} format='+1 (###) ###-####' displayType={'text'} />
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Other Phone</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>
              <NumberFormat value={application?.otherPhone} format='+1 (###) ###-####' displayType={'text'} />
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Date Of Birth</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>
              {formatDate3(new Date(application?.dob).toDateString())}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Last Four Social</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>{application?.lastFourSocial}</dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Yearly Income</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>
              {accountingFormatNumber({
                num: application?.incomeSources.wages ? application?.incomeSources.wages : 0,
                format: 'en-US',
                currency: 'USD',
              })}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Benefits/Pensions</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>
              {accountingFormatNumber({
                num: application?.incomeSources.pension ? application?.incomeSources.pension : 0,
                format: 'en-US',
                currency: 'USD',
              })}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Public Assistance</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>
              {accountingFormatNumber({
                num: application?.incomeSources.publicAssistance ? application?.incomeSources.publicAssistance : 0,
                format: 'en-US',
                currency: 'USD',
              })}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Social Security Income</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>
              {accountingFormatNumber({
                num: application?.incomeSources.ssi ? application?.incomeSources.ssi : 0,
                format: 'en-US',
                currency: 'USD',
              })}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Other Income</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>
              {accountingFormatNumber({
                num: application?.incomeSources.other ? application?.incomeSources.other : 0,
                format: 'en-US',
                currency: 'USD',
              })}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Gender</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>{application?.gender}</dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Marital Status</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>{application?.maritalStatus}</dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Disabled</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>{application?.disabled}</dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>City Employee</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>{application?.cityEmployee}</dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Race</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>{application?.races?.join?.(', ')}</dd>
          </div>
        </dl>
      </ReviewCard>
      {householdIncome?.length > 0 && (
        <ReviewCard title='People in Household' handleEdit={() => setCurrentStep(1)}>
          {householdIncome?.map((income: any, index: number) => (
            <div key={index} className='bg-white pt-5'>
              <div className='border rounded p-5 bg-white'>
                <h6 className='text-sm normal-case'>{income?.familyMemberName}</h6>
                <small className='text-gray-400'>{`${income.age}, ${income.relation}, ${accountingFormatNumber({
                  num: income?.wages || 0,
                })}`}</small>
              </div>
            </div>
          ))}
        </ReviewCard>
      )}
      <ReviewCard title='Application Information' handleEdit={() => setCurrentStep(2)}>
        <dl>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Street Address</dt>
            <dd className='mt-1 text-sm text-gray-900 normal-case sm:mt-0 sm:col-span-2'>{propertyInformation?.streetAddress}</dd>
          </div>

          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>City</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>{propertyInformation?.city}</dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>State / Province</dt>
            <dd className='mt-1 text-sm text-gray-900 normal-case sm:mt-0 sm:col-span-2'>{propertyInformation?.state}</dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Zip / Postal Code</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{propertyInformation?.zipCode}</dd>
          </div>

          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Work Phone</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>
              <NumberFormat value={propertyInformation?.workPhone} format='+1 (###) ###-####' displayType={'text'} />
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Buyers Name</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>{propertyInformation?.buyersAgentName}</dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Buyers Work Phone</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>
              <NumberFormat value={propertyInformation?.buyersWorkPhone} format='+1 (###) ###-####' displayType={'text'} />
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Buyers Agent Email</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>{propertyInformation?.buyersAgentEmail}</dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Sellers Name</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>{propertyInformation?.sellersName}</dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Sellers Agent Name</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>{propertyInformation?.sellersName}</dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Sellers Work Phone</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>
              <NumberFormat value={propertyInformation?.sellersWorkPhone} format='+1 (###) ###-####' displayType={'text'} />
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Sellers Agent Email</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>{propertyInformation?.sellersAgentEmail}</dd>
          </div>
        </dl>
      </ReviewCard>

      <ReviewCard title='Attachments' handleEdit={() => setCurrentStep(3)}>
        <dl>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>1st Mortgage Pre-Approval Letter</dt>
            {attachments?.approvalLetter?.selectedFiles.map((d: any, index: number) => (
              <dd key={index} className='mt-1 text-sm text-gray-900 normal-case sm:mt-0 sm:col-span-2 flex'>
                <DocumentIcon className='w-5 h-5' />
                {d.name}
              </dd>
            ))}
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Most Recent Tax Return</dt>
            {attachments?.taxReturn?.selectedFiles.map((d: any, index: number) => (
              <dd key={index} className='mt-1 text-sm text-gray-900 normal-case sm:mt-0 sm:col-span-2 flex'>
                <DocumentIcon className='w-5 h-5' />
                {d.name}
              </dd>
            ))}
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Two Months of Most Recent Pay Stubs</dt>
            {attachments?.payStubs?.selectedFiles.map((d: any, index: number) => (
              <dd key={index} className='mt-1 text-sm text-gray-900 normal-case sm:mt-0 sm:col-span-2 flex'>
                <DocumentIcon className='w-5 h-5' />
                {d.name}
              </dd>
            ))}
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>3 Months of Bank Statements</dt>
            {attachments?.bankStatements?.selectedFiles.map((d: any, index: number) => (
              <dd key={index} className='mt-1 text-sm text-gray-900 normal-case sm:mt-0 sm:col-span-2 flex'>
                <DocumentIcon className='w-5 h-5' />
                {d.name}
              </dd>
            ))}
          </div>
        </dl>
      </ReviewCard>
    </div>
  );
}
